import { IClassNameProps } from '@bem-react/core';
import React, { DetailedHTMLProps, HTMLAttributes } from 'react';

import cn from 'utils/cn';

import './index.css';

interface IHtmlContentProps extends IClassNameProps,
    DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    tag?: string;
    content: string;
}

const cnHtmlContent = cn('html-content');

function HtmlContent({ tag: TagName = 'div', content, className, ...props }: IHtmlContentProps) {
    // @ts-ignore
    return (<TagName
        className={cnHtmlContent({}, [className])}
        dangerouslySetInnerHTML={{ __html: content }}
        {...props}
        />);
}

export default HtmlContent;
